module.exports = __webpack_public_path__ + "static/media/analysis-after.3bfbe2f9.png";